import { DynamicTab } from "../../../components/Page";
import { RuvnlTitle } from "../components";
import { TabSwitcher } from "../Raj_Dashboard";
import Contract from "./Contract/Contract";

export function RajAutomation() {
  return (
    <DynamicTab
      header="Automation"
      middleComponent={<RuvnlTitle />}
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        "Net Schedule": (
          <div className="page-container">
            {" "}
            <iframe
              className="full-frame"
              title={"GNA"}
              src={"https://ruvitl.gna.energy/upload"}
              allowFullScreen={true}
            ></iframe>
          </div>
        ),
        "Contract Scheduling": <Contract />,
      }}
    />
  );
}
